// src/mocks/handlers/account/kycProcessHandler.ts

import { rest } from 'msw';
import { API_ENDPOINTS } from '@/services/api/endpoints';
import { VITE_MSW_BASE_URL } from '@/config';
import { isAccessTokenExpired } from '@/mocks/lib/authTokenUtils';
import { IKYCProcessResponse } from '@/domains/account/kyc/kyc.types';

export const kycProcessHandler = rest.post(
  `${VITE_MSW_BASE_URL}${API_ENDPOINTS.ACCOUNT_KYC_PROCESS}`,
  async (req, res, ctx) => {
    if (isAccessTokenExpired()) {
      return res(ctx.status(401), ctx.json({ error: 'Access token expired' }));
    }

    // Simulate KYC process URL generation
    const response: IKYCProcessResponse = {
      status: 'success',
      url: `https://www.google.com`,
    };

    return res(ctx.status(200), ctx.json(response));
  },
);
